import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Mail, MapPin, MessageCircle } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-slate-200 bg-slate-950 text-slate-300" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-3 text-xl font-bold tracking-tight text-white">EQUI<span className="text-blue-500">-</span>TEC</div>
            <p className="max-w-md text-sm leading-relaxed text-slate-400">{t("home.subtitle")}</p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-white">{t("nav.catalog")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/catalog" className="hover:text-blue-400">{t("categories.assembly")}</Link></li>
              <li><Link to="/catalog" className="hover:text-blue-400">{t("categories.cutting")}</Link></li>
              <li><Link to="/catalog" className="hover:text-blue-400">{t("categories.soldering")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-white">{t("nav.contact")}</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-500" /> <span>equi-tec di Daniele Reggi<br />via Canaletto 25/3<br />48022 Lugo (RA), Italia</span></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-blue-500" /> info@equi-tec.com</li>
              <li><a href="https://wa.me/393345742549" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-green-400" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-green-500" /> WhatsApp +39 334 574 2549</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row">
          <span>© {new Date().getFullYear()} Equi-Tec. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/imprint" className="hover:text-blue-400" data-testid="footer-imprint">{t("nav.imprint")}</Link>
            <Link to="/contact" className="hover:text-blue-400">{t("nav.contact")}</Link>
            <Link to="/login" className="hover:text-blue-400">{t("nav.login")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
